/**
 * useValeoProxyListener.ts
 * src/utils/ — même convention que useChatwoot.ts
 *
 * Écoute le postMessage envoyé par valeo.n.parts (proxy Valeo)
 * et re-émet un CustomEvent DOM vers ValeoHubilBridge.
 * N'utilise AUCUN contexte React — peut être appelé dans CaiaApp directement.
 */
import { useEffect } from 'react';

const VALEO_PROXY_ORIGIN =
    process.env.REACT_APP_VALEO_PROXY_ORIGIN || '*';

export const VALEO_HUBIL_EVENT = 'valeo:openHubil';

export const useValeoProxyListener = (): void => {
    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (
                VALEO_PROXY_ORIGIN !== '*' &&
                event.origin !== VALEO_PROXY_ORIGIN
            ) {
                return;
            }
            const { data } = event;
            if (!data || data.type !== 'NODEAUTO_OPEN_HUBIL') return;

            const ref = data.ref as string | undefined;
            if (!ref) {
                console.warn('[ValeoProxy] postMessage sans ref', data);
                return;
            }
            console.log(`[ValeoProxy] ref reçue : ${ref}`);
            window.dispatchEvent(
                new CustomEvent(VALEO_HUBIL_EVENT, { detail: { ref } })
            );
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);
};
